import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-slack',
  templateUrl: './slack.component.html',
  styleUrls: ['./slack.component.scss']
})
export class SlackComponent implements OnInit {
  loading = true;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    const urlString = this.router.url;

    const code = urlString.match(/code=([^&]*)/)[1];
    const state = urlString.match(/state=([^&]*)/)[1];
    if (state == 'localhost:4200') {
      window.location.href = 'https://localhost:4200/system-settings/slack/' + code;
    } else {
      window.location.href = 'https://' + state + '.collabtic.com/system-settings/slack/' + code;
    }

  }

}
